<template>
  <div class="feedback">
  
    <index-view title="Danh sách feedback" :filters="filters" :getData="getData" :getDetail="getDetail" :headers="mainHeaders" 
    :detailWidth="1000" :cellSlots="cellSlots" tableKey="id" :itemsPerPage="100">
      <template #viewSection="{ item, selected }" >
        <detail :item="item" :selected="selected"></detail>
      </template>
        
      <template v-slot:[`status`]="{ cell, reload }">
        <span class="font-weight-bold">{{ cell.status == 0 ? 'Mới' : 'Đã xử lý' }}</span>
        <!-- <b :key="'status'" :class="convertStatus(cell?.status).color">{{ convertStatus(cell?.status).text }}</b> -->
      </template>

      <template #action1>
        <v-btn text color="red" style="text-transform: none;" small class="mx-1" @click="action1Dialog=true">Chốt kỳ</v-btn>
        <v-dialog v-model="action1Dialog" max-width="800">
          <v-card class="rounded-lg">
            <v-card-title class="text-subtitle-1">
              Chốt kỳ đánh giá nhân viên
              <v-spacer></v-spacer>
              <v-btn icon color="red" @click="action1Dialog=false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
            <v-row>
              <v-col cols="12">
                <!-- <v-text-field v-model="actionData.month" label="Kỳ chốt" placeholder="" persistent-placeholder type="date" outlined>
                </v-text-field> -->
                
                  <v-select label="Chọn năm" v-model="sessionYear" placeholder="" persistent-placeholder hide-details :items="yearOptions"></v-select>
                  
              </v-col>
            </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>

    </index-view>
    
  </div>
</template>

<script>

import IndexView from '@/components/CommonView/IndexView.vue';
import { get,detail } from './api'
import { main, finalHeaders, readyHeaders } from './header'
import Detail from './Detail.vue'
// import EmployeeDialog from '../../../components/Crud/Prompt/EmployeeDialog.vue';
import moment from 'moment';
const statusFilters = ['Tạo mới', 'Hoàn tất', 'Hủy']
export default {
  name: "FeedBack",
  components: {
    IndexView,
    Detail,
    // EmployeeDialog
  },
  computed: {
    mainHeaders () {
      return main(this.filters)
    },
    yearOptions() {
      let thisYear = moment().year();
      let lowerYear = thisYear - 5;
      let upperYear = thisYear + 5;
      var yearOptions = [];
      for(let y = lowerYear; y <= upperYear; y++) {
        yearOptions.push(y);
      }

      return yearOptions;
    }

  },
  data() {
    return {
      filters: [
        {name: 'id', label:'Id', type: 'text', value: '' },
        {name: 'keyEmployeeCode', label:'Mã NS', type: 'text', value: '' },
        {name: 'keyEmployeeName', label:'Tên NS', type: 'text', value: '' },
        // {name: 'status', label:'Trạng thái', type: 'select', selectItems: statusFilters, value: '' },
      ],
      cellSlots: ['status', 'approvedByCode', 'totalScoreNvm', 'totalScoreCot2', 'keyEmployeeHireDate'],
      selected: null,
      action1Dialog: false,
      actionData: {
        month: null
      },
      finals: [],
      finalHeaders : finalHeaders,
      sessionYear: moment().year(),

      action2Dialog: false,
      action2Calendar: null,
      readySearch: '',
      readies: [],
      readyHeaders: readyHeaders,
      readyLoading: false,

      employeeDialog: false,
      employeeDialogMain: false,
    }
  },
  watch: {
    action2Calendar(newVal) {
      this.getReady();
    },
    sessionYear(newVal) {
      this.getFinalSession();
    }
  },
  methods: {
    getData: get,
    getDetail: detail,
    actionSubmit(item) {
      return setFinal(item.month).then(() =>{
        // this.action1Dialog = false;
      }).finally(() => {
        this.getFinalSession();
      })
    },
    actionRemove(item) {
      return removeFinal(item.month).then(() => {
        this.finals = this.finals.filter(i => i.month !== item.month)
      }).finally(() => {
        this.getFinalSession();
      })
    },
    getFinal() {
      return getFinal().then(data => {
        this.finals = data.data.map(item => {
          item.month = this.$formatter.formatDate(item.month, 'MM/YYYY')
          return item
        });
      })
    },

    getFinalSession() {
      return getFinalSession(this.sessionYear).then(data => {
        this.finals = data.data.map(item => {
          item.month = this.$formatter.formatDate(item.month, 'MM/YYYY')
          return item
        });
      })
    },

    //ready section
    getReady() {
      this.readyLoading =true
      return getReady(this.action2Calendar).then(data => {
        this.readies = data.data;
      }).finally(() => {
        this.readyLoading =false
      })
    },
    
    setReady() {
      //call api to set ready items
      if(!this.action2Calendar) {
        alert('Vui lòng chọn kỳ đánh giá');
        return;
      }
      return setReady(this.action2Calendar).then(() => {
        this.getReady();
      })
    },
    setEmployee(value) {
      var empObj = value[0]
      if(value.length == 0) {
        return changeConfirmedBy(this.selected.id, '').then(() => {
          this.selected.smCode = ''
          this.selected.smName = ''
          this.employeeDialog = false
        }).finally(() => {
          this.selected = null
        })
      }else {
        return changeConfirmedBy(this.selected.id, empObj.code).then(() => {
          this.selected.smCode = empObj.code
          this.selected.smName = empObj.name
          this.employeeDialog = false
        }).finally(() => {
          this.selected = null
        })
      }
    },
    setReviewApprove(value) {
      var empObj = value[0]
      if(value.length == 0) {
        return changeApprovedBy(this.selected.id, null).then(() => {
            this.selected.approvedByCode = null
            this.selected.approvedByName = null
            this.employeeDialogMain = false
          }).finally(() => {
            this.selected = null
          })
      }else {
        return changeApprovedBy(this.selected.id, empObj.code).then(() => {
          this.selected.approvedByCode = empObj.code
          this.selected.approvedByName = empObj.name
          this.employeeDialogMain = false
        }).finally(() => {
          this.selected = null
        })
      }
    },
    
    initReady() {
      //call api to set ready items
      if(!this.action2Calendar) {
        alert('Vui lòng chọn kỳ đánh giá');
        return;
      }
      return initReady(this.action2Calendar).then(() => {
        this.getReady();
      })
    },

    generateReview() {
      //call api to generate review for ready items
      if(!this.action2Calendar) {
        alert('Vui lòng chọn kỳ đánh giá');
        return;
      }
      return generateReview(this.action2Calendar).then(() => {
        this.getReady();
      })
    },
    convertStatus(status) {
      if(status === 0) return {text:'Tạo mới', color:'cyan--text'}
      if(status === 1) return {text:'SM duyệt', color:'green--text'}
      if(status === 2) return {text:'Lưu trữ', color:'blue--text'}
      return {text:'Hủy', color:'red--text'}
    }
  },
  mounted() {
    // this.getFinal().then(d => {
    // });

    this.getFinalSession(2025)
  }
}
</script>